exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".accounting-system-settings-overlay label[data-v-5237f1c5]{margin-bottom:0}.accounting-system-settings-overlay input[type=checkbox]+label[data-v-5237f1c5]{font-weight:300}.error-message[data-v-5237f1c5]{color:red;font-size:.8em}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5237f1c5","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/_modules/Programs/Card-list/AccountingSystemSettings.vue
// module id = 6Xis
// module chunks = 12